export class LocationUpdateRequest{
    stockId: number;
    rackPosition:number;
    constructor(stockId:number,rackPosition:number){
        this.stockId = stockId;
        this.rackPosition = rackPosition;
    }
}
